import { UP2RENT_APP_URL } from '@rentguru/commons-utils';

import { getCurrentEnv } from 'src/utils/envUtils';

const COMMUNICATION_API_URL_OVERRIDE = import.meta.env.VITE_COMMUNICATION_API_URL;

export const getCommunicationAttachmentsDownloadUrl = (communicationId: string): string => {
  const baseUrl = COMMUNICATION_API_URL_OVERRIDE ?? `https://communication.api.${getCurrentEnv()}.${UP2RENT_APP_URL}`;
  return `${baseUrl}/r/${communicationId}`;
};
